import { createStandardAction } from 'typesafe-actions';

const TOGGLE = 'language/TOGGLE';

export const toggle = createStandardAction(TOGGLE)<boolean>();



// WEBPACK FOOTER //
// ./src/store/modules/language/actions.ts